import universityHeroBackground from "../../../assets/branding/tessera-university-hero.png";

/** University page hero banner (from `public/Background Images/tessera university.png`). */
export const UNIVERSITY_HERO_BACKGROUND_SRC = universityHeroBackground;

/** Logical 1x layout size (asset is 2400×800 @2x). */
export const UNIVERSITY_HERO_BACKGROUND_WIDTH = 1200;
export const UNIVERSITY_HERO_BACKGROUND_HEIGHT = 400;
